import { staticSelector } from 'ducks/static'
import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import {
  Container,
  Content,
  Title,
  CardDesign,
  Left,
  LeftIconContainer,
  Icon,
  TextContainer,
  Info,
  Vector,
  Right,
  RightIconContainer,
  InfoGrey,
  InfoGreen,
} from '../styledCard'
import vector from 'assets/Vector6.png'
import iconVoc from 'assets/icon_voc.png'
import { Metric } from '../../MetricsPage/types'

interface Props {
  data: Metric
}

export const Card7: FC<Props> = ({ data }) => {
  const state = useSelector(staticSelector)

  const { title, iconLeft, iconRight, textLeft, textRight } = state.content?.nationalMetric.subTabRender[3]
  const { iconRight: iconTruck } = state.content?.nationalMetric.subTabRender[2]

  return (
    <Container>
      <Content>
        {/* {title ? <Title>{title}</Title> : null} */}
        <CardDesign>
          <Left>
            <LeftIconContainer leftColor="#777777">{iconVoc ? <Icon src={iconVoc} /> : null}</LeftIconContainer>
            <TextContainer>
              <>
                <Info>
                  <InfoGrey leftColor="#777777">{data.voc} lbs of volatile organic compounds</InfoGrey>(VOCs)
                </Info>
              </>
            </TextContainer>
          </Left>
          <Vector src={vector} />
          <Right>
            <RightIconContainer rightColor="#54AE2A">
              {iconTruck.url ? <Icon src={iconTruck.url} /> : null}
            </RightIconContainer>
            <TextContainer>
              <Info>
                That’s the equivalent of <InfoGreen>{data.voc_visual} lbs of VOCs prevented from</InfoGreen>
                contributing to ground level ozone smog
              </Info>
            </TextContainer>
          </Right>
        </CardDesign>
      </Content>
    </Container>
  )
}
